import React from "react";
import type { ReactElement } from "react";

import { RadioOption } from "design_system/components/Radio";
import type { UrlTreePbu, UrlTreeOptionProps, UrlTreeRadioOption } from "../../ds__types";

const UrlTreeOptions = (props: UrlTreeOptionProps): ReactElement => {
    const { filteredPbus, selectedPbuId, handleSelectPbu } = props;

    const labelLogo = (logo: string, name: string) => (
        <img className="max-h-64" src={logo} alt={name} />
    );
    const radioOptions = filteredPbus.map((pbu: UrlTreePbu) => ({
        key: pbu.id,
        name: "providerOptions",
        value: pbu.id,
        label: labelLogo(pbu.logo, pbu.name),
        labelClassName: "p-16",
        className: `flex items-center`,
        checked: selectedPbuId === pbu.id,
    }));

    return (
        <div className="flex flex-col">
            <div className="mt-24 text-gray-65657b text-0_875 font-500">
                {gettext("Select provider:")}
            </div>
            {radioOptions.map((option: UrlTreeRadioOption) => {
                return (
                    <div
                        key={option.key}
                        className={`flex items-center border pl-16 mt-16 rounded-8 h-96 ${
                            option.checked
                                ? "border-primary-3667e9 bg-primary-f2f8ff"
                                : "border-gray-a9acc4"
                        }`}
                    >
                        <RadioOption {...option} onChange={handleSelectPbu} />
                    </div>
                );
            })}
        </div>
    );
};

export default UrlTreeOptions;
